import React from "react";

export default function TableColumnDecorator(Component : any , props : any) {
    return (
        <Component {...props} />
    );
}
